import usePagination from '@/hooks/usePagination';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import { JobEntityStatusEnum, JobPurposeEnum } from '@/types/schema';

import { useJobsQuery } from '../../graphql/queries/generated/jobs';

interface JobsParams {
  status: JobEntityStatusEnum[];
  purpose: JobPurposeEnum[];
}

const useJobs = (params: JobsParams) => {
  const { id } = useUserContext();
  const { data, error, refetch } = usePagination(
    useJobsQuery,
    {
      filters: { createdByIds: [id], ...params },
    },
    { edgeKey: 'jobs', requestPolicy: 'cache-and-network' },
  );

  return { error, jobs: data, refetch };
};

export default useJobs;
